import { useTranslation } from 'react-i18next';
import { Anchor, Button, Group, Stack } from '@mantine/core';
import { IconFileText, IconTrash } from '@tabler/icons-react';
import type { OrderFile } from '@/types/buy';
import type { UploadedFile } from '@/types/sell';

interface FileListProps {
  readonly files: (UploadedFile | OrderFile)[];
  readonly onRemove: (id: number) => void;
  readonly onDownload: (id: number) => void;
  /** Мутация удаления — для спиннера на удаляемом файле (isPending + variables=id). */
  readonly removing: { isPending: boolean; variables?: number };
}

// Список загруженных файлов: имя (скачать) + удалить. Общий для декларации/особых условий оффер-формы
// и блока декларации страницы сделки.
export default function FileList({ files, onRemove, onDownload, removing }: FileListProps) {
  const { t } = useTranslation();
  if (files.length === 0) {
    return null;
  }
  return (
    <Stack gap={6}>
      {files.map((file) => (
        <Group key={file.id} justify="space-between" wrap="nowrap" gap="sm">
          <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
            <IconFileText size={18} color="var(--mantine-color-brand-6)" style={{ flexShrink: 0 }} />
            {/* Кнопка, а не ссылка без адреса: иначе файл не открыть с клавиатуры (Tab его пропускал). */}
            <Anchor component="button" type="button" size="sm" c="brand.7" onClick={() => onDownload(file.id)} style={{ minWidth: 0 }} truncate="end">
              {file.name ?? `#${file.id}`}
            </Anchor>
          </Group>
          <Button
            variant="subtle"
            color="red"
            size="compact-sm"
            leftSection={<IconTrash size={14} />}
            loading={removing.isPending && removing.variables === file.id}
            onClick={() => onRemove(file.id)}
          >
            {t('app.sell.lot.delete')}
          </Button>
        </Group>
      ))}
    </Stack>
  );
}
